import { render, staticRenderFns } from "./HpSpinner.vue?vue&type=template&id=66672d49&scoped=true"
import script from "./HpSpinner.vue?vue&type=script&lang=js"
export * from "./HpSpinner.vue?vue&type=script&lang=js"
import style0 from "./HpSpinner.vue?vue&type=style&index=0&id=66672d49&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66672d49",
  null
  
)

export default component.exports